export default {"src":"/_next/static/media/how_paid.b8e9c43d.svg","height":83,"width":58,"blurWidth":0,"blurHeight":0};